import { useEffect, useState } from 'react';
import { summaryItem } from './_config';
import {
  getCoverage,
  getDataSummary,
  getMonthSummary,
  getMonthSummaries,
  getMonthlyUpdated,
  getHistoricalMagnitude,
} from '@/pages/intelligence/services/sourceMetrics';
import moment from 'moment';

import { dbiPageLogMes } from '@/pages/intelligence/utils/buriedPointCfg';
import { buriedPointPage } from '@/pages/home/utils/buriedPoint';

export default (props) => {
  const [summaryInfo, setSummaryInfo] = useState(summaryItem);

  const [loadingDataSummary, setLoadingDataSummary] = useState(true);
  const [loadingHistoricalMagnitude, setLoadingHistoricalMagnitude] = useState(true);
  const [loadingMonthlyUpdatedGames, setLoadingMonthlyUpdatedGames] = useState(true);
  const [loadingMarketsCoverage, setLoadingMarketsCoverage] = useState(true);
  const [loadingTopGamesCoverage, setLoadingTopGamesCoverage] = useState(true);
  const [loadingCompanyCoverage, setCompanyCoverage] = useState(true);
  const [loadingMonthSummaryData, setLoadingMonthSummaryData] = useState(true);

  const pageLogMes = dbiPageLogMes.sourcesMetricsOverview;

  const getSummary = async () => {
    setLoadingDataSummary(true);
    try {
      const result = await getDataSummary();
      const tempList = [];
      if (result) {
        for (const key in summaryItem) {
          let data = 0;
          const item = summaryItem[key];
          switch (key) {
            case 'mobileGame':
              data = result.mobile_games || 0;
              break;
            case 'pcGame':
              data = result.pc_games || 0;
              break;
            case 'consoleGame':
              data = result.console_games || 0;
              break;
            case 'dataSource':
              data = result.data_sources || 8;
              break;
            case 'crawlers':
              data = result.crawlers || 174;
              break;
            case 'companies':
              data = result.companies || 0;
              break;
            case 'countries':
              data = result.markets || 71;
              break;
            case 'news':
              data = result.news || 0;
              break;
            case 'options':
              data = result.opinions || 0;
              break;
            case 'comments':
              data = result.comments || 0;
          }
          item.num = data;
          tempList.push(item);
        }
        setSummaryInfo(tempList);

        setLoadingDataSummary(false);
      }
    } catch (e) {
      console.log(e);

      setLoadingDataSummary(false);
    }
  };

  const [loading, setLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [multipleAreaData, setMultipleAreaData] = useState({
    mobileYAxis: [],
    pcYAxis: [],
    consoleYAxis: [],
    xAxis: [],
    totalNow: 0,
    totalChange: 0,
  });

  const [monthlyUpdatedData, setMonthlyUpdatedData] = useState({
    mobileYAxis: [],
    pcYAxis: [],
    consoleYAxis: [],
    xAxis: [],
    totalNow: 0,
    totalChange: 0,
  });

  const [marketCoverage, setMarketCoverage] = useState([]);
  const [lastMonth, setLastMonth] = useState('');

  const pieColorSet = {
    mobile: ['#F2F3F5', '#5086F3'],
    pc: ['#F2F3F5', '#5EC8F1'],
    console: ['#F2F3F5', '#69D19C'],
  };

  const lineColorSet = ['#5086F3', '#5EC8F1', '#69D19C'];

  const getMarketCoverage = () => {
    setLoadingMarketsCoverage(true);
    getCoverage('markets', {})
      .then((data) => {
        setMarketCoverage(data);
        const lastMonth = moment(new Date()).subtract(1, 'months').format('YYYY-MM');
        setLastMonth(lastMonth);
      })
      .catch((err) => {
        console.log(err);
        setIsError(true);
      })
      .finally(() => {
        setLoadingMarketsCoverage(false);
      });
  };

  const getHistoricalMagnitudeChartData = () => {
    setLoadingHistoricalMagnitude(true);
    Promise.all([
      getHistoricalMagnitude({ entity_type: 'mobile' }),
      getHistoricalMagnitude({ entity_type: 'pc' }),
      getHistoricalMagnitude({ entity_type: 'console' }),
    ])
      .then(([mobileData, pcData, consoleData]) => {
        // console.log(mobileData, pcData, consoleData)
        const { mobileYAxis, pcYAxis, consoleYAxis, xAxis, totalNow, totalChange } = formatData(
          mobileData,
          pcData,
          consoleData,
        );

        // console.log({ mobileYAxis, pcYAxis, consoleYAxis, xAxis, totalNow, totalChange })

        setMultipleAreaData({ mobileYAxis, pcYAxis, consoleYAxis, xAxis, totalNow, totalChange });
      })
      .catch((err) => {
        console.log(err);
        setIsError(true);
      })
      .finally(() => {
        setLoadingHistoricalMagnitude(false);
      });
  };

  const getMonthlyUpdatedChartData = () => {
    setLoadingMonthlyUpdatedGames(true);
    Promise.all([
      getMonthlyUpdated({ entity_type: 'mobile' }),
      getMonthlyUpdated({ entity_type: 'pc' }),
      getMonthlyUpdated({ entity_type: 'console' }),
    ])
      .then(([mobileData, pcData, consoleData]) => {
        // console.log(mobileData, pcData, consoleData)
        const { mobileYAxis, pcYAxis, consoleYAxis, xAxis, totalNow, totalChange } = formatData(
          mobileData,
          pcData,
          consoleData,
        );

        // console.log({ mobileYAxis, pcYAxis, consoleYAxis, xAxis, totalNow, totalChange })

        setMonthlyUpdatedData({ mobileYAxis, pcYAxis, consoleYAxis, xAxis, totalNow, totalChange });
      })
      .catch((err) => {
        console.log(err);
        setIsError(true);
      })
      .finally(() => {
        setLoadingMonthlyUpdatedGames(false);
      });
  };

  const MonthSummaryType = ['news', 'social-media-opinions', 'game-store-comments'];
  const [lineChartList, setLineChartList] = useState([]);

  const getMonthSummaryData = () => {
    setLoadingMonthSummaryData(true);
    // Promise.all([
    //   getMonthSummary({ entity_type: 'news' }),
    //   getMonthSummary({ entity_type: 'social' }),
    //   getMonthSummary({ entity_type: 'comments' }),
    // ])
    getMonthSummaries({ entity_types: ['news', 'social', 'comments'] })
      .then(({ news, social, comments }) => {
        // console.log(mobileData, pcData, consoleData)
        const { mobileYAxis, pcYAxis, consoleYAxis, xAxis } = formatData(news, social, comments);

        // console.log("SD", { mobileYAxis, pcYAxis, consoleYAxis, xAxis})

        const res = [mobileYAxis, pcYAxis, consoleYAxis].map((item, idx) => {
          return {
            title: MonthSummaryType[idx],
            data: {
              yAxis: item,
              xAxis,
            },
            totalNow: item.at(-1),
            change: (item.at(-1) - item.at(-2)) / item.at(-2),
            color: lineColorSet[idx],
          };
        });
        setLineChartList(res);
      })
      .catch((err) => {
        console.log(err);
        setIsError(true);
      })
      .finally(() => {
        setLoadingMonthSummaryData(false);
      });
  };

  const [pieList, setPieList] = useState([]);
  const [pieCompany, setPieCompany] = useState({});

  const getTopGameCoverage = () => {
    setLoadingTopGamesCoverage(true);
    getCoverage('top_game', {})
      .then((data) => {
        const pie3List = data?.map((item) => {
          const data = [
            { name: 'Other', value: item.total - item.total_daily },
            { name: 'DataBrain', value: item.total_daily },
          ];

          const change = (item.total - item.pre_total_daily) / item.pre_total_daily;
          return {
            data,
            change,
            type: item.entity_type,
            color: pieColorSet[item.entity_type],
            total: item.total,
            total_daily: item.total_daily,
          };
        });

        setPieList(pie3List);
      })
      .catch((err) => {
        console.log(err);
        setIsError(true);
      })
      .finally(() => {
        setLoadingTopGamesCoverage(false);
      });
  };

  const getCompanyCoverage = () => {
    setCompanyCoverage(true);
    getCoverage('company', {})
      .then((data) => {
        const chartData = [
          { name: 'Other', value: data.total - data.total_daily },
          { name: 'DataBrain', value: data.total_daily },
        ];

        const change = (data.total - data.pre_total_daily) / data.pre_total_daily;

        const res = {
          data: chartData,
          change,
          type: 'TOP COMPANY',
          color: pieColorSet.mobile,
          total: data.total,
          total_daily: data.total_daily,
        };

        setPieCompany(res);
      })
      .catch((err) => {
        console.log(err);
        setIsError(true);
      })
      .finally(() => {
        setCompanyCoverage(false);
      });
  };

  const formatData = (mobileData: any[], pcData: any[], consoleData: any[]) => {
    const mobileYAxis =
      mobileData?.reverse().map((item) => {
        return Number(item?.total) || 0;
      }) || [];
    const pcYAxis =
      pcData?.reverse().map((item) => {
        return Number(item?.total) || 0;
      }) || [];
    const consoleYAxis =
      consoleData?.reverse().map((item) => {
        return Number(item?.total) || 0;
      }) || [];

    const xAxis =
      mobileData?.map((item) => {
        return moment(item.start_date).format('YYYY-MM');
      }) || [];

    const totalNow = mobileYAxis?.at(-1) + pcYAxis?.at(-1) + consoleYAxis?.at(-1);
    const totalLast = mobileYAxis?.at(-2) + pcYAxis?.at(-2) + consoleYAxis?.at(-2);

    const totalChange = (totalNow - totalLast) / totalLast;

    // console.log(totalNow, totalLast, totalChange)

    return { mobileYAxis, pcYAxis, consoleYAxis, xAxis, totalNow, totalChange };
  };

  useEffect(() => {
    getSummary();
    getHistoricalMagnitudeChartData();
    getMonthlyUpdatedChartData();
    getMarketCoverage();
    getTopGameCoverage();
    getCompanyCoverage();
    getMonthSummaryData();
    buriedPointPage(pageLogMes);
  }, []);

  // console.log("PIE---", pieList)

  return {
    summaryInfo,
    multipleAreaData,
    monthlyUpdatedData,
    marketCoverage,
    lastMonth,
    pieList,
    pieCompany,
    lineChartList,
    loadingDataSummary,
    loadingHistoricalMagnitude,
    loadingMonthlyUpdatedGames,
    loadingMarketsCoverage,
    loadingTopGamesCoverage,
    loadingCompanyCoverage,
    loadingMonthSummaryData,
  };
};
